import { textStyle } from "theme/names";
import { GiCheckMark } from "react-icons/gi";

import {
  Box,
  Card,
  Flex,
  Text,
} from "@chakra-ui/react";
import { TextArea } from "components/post-generator/TextArea";
import { useState } from "react";
export const QA = ({
  questionString = "",
  placeHolder = "",
  inputType = "textarea",
  inputProps = {},
  containerProps = {},
  infoBelowInput = "",
  inputIndentifier = "",
  infoBelowInputIcon = <GiCheckMark size="18" color="#515d6a" />,
  onInputChangeCallBack = (val: any, id: any = undefined, elem: any = undefined) => { },
  containerRef = null as any,
}) => {
  const [textAreaValue, setTextAreaValue] = useState();

  const handleInput = async (e: any) => {
    setTextAreaValue(e?.target?.value);
    onInputChangeCallBack(e?.target?.value, inputIndentifier, e?.target);
  }

  return (
    <Box {...containerProps} px={[5, 10]} ref={containerRef}>
      <Flex py="2" justifyContent="space-between" alignItems="center" ml={[1, 6]} w={"full"}>
        <Flex flexDirection={"column"} w={"full"}>
          <Text fontSize="2xl" textStyle={textStyle["body.medium.primary"]} mb={3} w={"full"}>
            {questionString}
          </Text>
          <Card
            paddingTop="2"
            paddingLeft="4"
            w={"full"}
          >
            {inputType === "textarea" && (
              <TextArea
                props={{
                  "placeholder": placeHolder,
                  "value": textAreaValue,
                  "name": inputIndentifier,
                  "onChange": (e: any) => handleInput(e),
                  ...inputProps
                }}
              />
            )}

          </Card>

          {infoBelowInput &&
            (
              <Flex flexDir={"row"} gap="4" mt={3}>
                <Text>{infoBelowInputIcon}</Text>
                <Text
                  fontSize="sm"
                  textStyle={textStyle["body.medium.primary"]}
                  color={"#515d6a"}
                >
                  {infoBelowInput}
                </Text>
              </Flex>
            )}
        </Flex>
      </Flex>
    </Box>
  )
}